module.exports = __webpack_public_path__ + "img/IcnMbMenuClose.1fefbf89.png";